import type { Settings as LayoutSettings } from "@ant-design/pro-components";

const defaultSettings: Partial<LayoutSettings> = {
  navTheme: "light",
  layout: "mix",
  contentWidth: "Fluid",
  fixedHeader: true,
  fixSiderbar: true,
  splitMenus: false,
};

export default defaultSettings;
